import React from 'react';
import { ArrowRight } from 'lucide-react';

// Renders a horizontal (stacked on mobile) user-flow diagram from staged steps.
export const UserFlow = ({ flow }) => {
  if (!flow || !flow.stages) return null;
  return (
    <div className="flex flex-col lg:flex-row items-stretch gap-3" data-testid="user-flow-diagram">
      {flow.stages.map((stage, i) => (
        <React.Fragment key={i}>
          <div className="glass rounded-2xl p-5 flex-1">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-7 h-7 rounded-full glass-btn flex items-center justify-center text-xs font-mono text-zinc-300">
                {i + 1}
              </span>
              <h4 className="font-heading font-bold text-white">{stage.title}</h4>
            </div>
            <div className="space-y-2.5">
              {stage.steps.map((step, j) => (
                <div key={j} className="flex items-center gap-2.5 text-sm text-zinc-400">
                  <span className="w-1.5 h-1.5 rounded-full bg-zinc-500 shrink-0" />
                  {step}
                </div>
              ))}
            </div>
          </div>
          {i < flow.stages.length - 1 && (
            <div className="flex items-center justify-center text-zinc-600 rotate-90 lg:rotate-0">
              <ArrowRight size={20} />
            </div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default UserFlow;
